<div  class="text-center question-body" *ngIf="question && !loading">
 <div [appMath]="title"></div>
  <div>
   <span *ngIf="questionText" [innerHTML]="questionText"></span>
  </div>


  <div *ngIf="question.is_multipart==0">
    <form [formGroup]="doQuestionForm"  *ngIf="question.server_question_id!=0">
      <span *ngIf="question['is_radio_group']">
       <div>(<i>Select the Correct Answer from options below</i>)</div>
        <table class="table">
          <tbody>
            <tr *ngFor="let choice of question.choiceOptions; index as myCount">
            <td>
               <div class="answer-option-radio-div">
                 <input
                 type="radio"
                 [id]="myCount"
                 [checked]="choice.name=='answer'"
                 formControlName="answerChoice"
                 [value]="extractChoiceValue(choice)"
                 style="height:35px; width:35px; vertical-align: middle;"/>
                 <span [innerHTML]="choice.display"></span>
            </div>
            </td>
        </tr>
      </tbody>
         </table>
        </span>
            <div class="row"  *ngIf="question['is_input']">
                <div class="col-sm-4" ></div>
                <div class="col-sm-4" >
                    <input   formControlName="answerInput" class="form-control mt-4" placeHolder="Type answer Here" />
                </div>
            </div>

      </form>
  </div>

    <div *ngIf="question.is_multipart==1">
      <span *ngIf="question.prompts.length>0">
        <app-do-prompt
        *ngFor="let prompt of question.prompts"
        [prompt]="prompt"
        [quizEnvelop]="quizEnvelop"
        [questionIndex]="questionIndex"
        [isLastQuestion]="isLastQuestion"
        [answerGiven]="answerGiven">
        </app-do-prompt>
        </span>
    </div>

    <div *ngIf="question" class="m-2">
      <h2 class="text-center"> Answer View </h2>
      <app-revise-question [question]="question"></app-revise-question>
    </div>

</div>
<div *ngIf="!question">
<app-spinner></app-spinner>
</div>


<app-view-sample-detail *ngIf="question"
[sampleTaskDetail]="question.template_detail"
(viewSampleTaskDetailFinished)="onViewSampleDetailFinished()">
</app-view-sample-detail>

<div class="text-center">
  <a [routerLink]="['/task/template/show/',server_task_template_id]" class="btn btn-primary m-2"> Back to Template</a>
  <button (click)="generateSampleTask()" class="btn btn-primary m-2">
    <span *ngIf="generating" class="spinner-border spinner-border-sm"></span>
      Re Generate
    </button>
    <button (click)="reloadSampleTask()" class="btn btn-primary m-2">
    <span *ngIf="reloading" class="spinner-border spinner-border-sm"></span>
      Re Load
    </button>
    <a [routerLink]="['/task/template/list']" class="btn btn-primary m-2" ><i class="fa fa-list"></i>  List</a>
      <button (click)="viewSampleTaskDetailPopUp()" class="btn btn-primary m-2" ><i class="fa fa-eye"></i>  View Detail</button>
      <a [routerLink]="['/task/template/edit',server_task_template_id]" class="btn btn-primary m-2" >
        <i class="fa fa-edit"></i> Edit
      </a>
      <button (click)="movePrevious()" class="btn btn-primary m-2" > Previous</button>
      <button (click)="moveNext()" class="btn btn-primary m-2" > Next</button>
</div>
<div class="text-center"><span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span></div>
